// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"dd31006766--tooltip--dS2c9","content":"dd31006766--content--QRubu"};